import React from "react";
import ReactEcharts from "echarts-for-react";

export const mockData = {
  energy: {
    data: [
      { key: "jan", value: 10, label: "ม.ค." },
      { key: "feb", value: 20, label: "ก.พ." },
      { key: "mar", value: 30, label: "มี.ค." },
      { key: "apr", value: 40, label: "เม.ย." },
      { key: "may", value: 50, label: "พ.ค." },
      { key: "jun", value: 60, label: "มิ.ย." },
      { key: "jul", value: 70, label: "ก.ค." },
      { key: "aug", value: 80, label: "ส.ค." },
      { key: "sep", value: 90, label: "ก.ย." },
      { key: "oct", value: 100, label: "ต.ค." },
      { key: "nov", value: 110, label: "พ.ย." },
      { key: "dec", value: 120, label: "ธ.ค." },
    ],
  },
  garbage: {
    data: [
      { key: "jan", value: 5, label: "ม.ค." },
      { key: "feb", value: 20, label: "ก.พ." },
      { key: "mar", value: 30, label: "มี.ค." },
      { key: "apr", value: 40, label: "เม.ย." },
      { key: "may", value: 50, label: "พ.ค." },
      { key: "jun", value: 60, label: "มิ.ย." },
      { key: "jul", value: 70, label: "ก.ค." },
      { key: "aug", value: 80, label: "ส.ค." },
      { key: "sep", value: 90, label: "ก.ย." },
      { key: "oct", value: 100, label: "ต.ค." },
      { key: "nov", value: 110, label: "พ.ย." },
      { key: "dec", value: 120, label: "ธ.ค." },
    ],
  },
};

const mappingMonth: any = {
  มกราคม: "ม.ค.",
  กุมภาพันธ์: "ก.พ.",
  มีนาคม: "มี.ค.",
  เมษายน: "เม.ย.",
  พฤษภาคม: "พ.ค.",
  มิถุนายน: "มิ.ย.",
  กรกฎาคม: "ก.ค.",
  สิงหาคม: "ส.ค.",
  กันยายน: "ก.ย.",
  ตุลาคม: "ต.ค.",
  พฤศจิกายน: "พ.ย.",
  ธันวาคม: "ธ.ค.",
};

const mappingMonth2: any = {
  January: "ม.ค.",
  February: "ก.พ.",
  March: "มี.ค.",
  April: "เม.ย.",
  May: "พ.ค.",
  June: "มิ.ย.",
  July: "ก.ค.",
  August: "ส.ค.",
  September: "ก.ย.",
  October: "ต.ค.",
  November: "พ.ย.",
  December: "ธ.ค.",
};

type BarStackChartProps = {
  data: {
    [key: string]: {
      data: { key: string; value: number; label: string }[];
      color: string;
    };
  };
  title: string;
  yAxisName: string;
  height: string;
};
export const BarStackChart: React.FC<BarStackChartProps> = ({
  data,
  title,
  yAxisName,
  height,
}) => {
  const options = {
    title: {
      text: title,
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: Object.keys(data),
      bottom: "5%",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "15%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: data[Object.keys(data)[0]].data.map(
          (item) => mappingMonth[item.label] || mappingMonth2[item.label]
        ),
      },
    ],
    yAxis: [
      {
        type: "value",
        name: yAxisName,
      },
    ],
    series: Object.keys(data).map((key, index) => ({
      name: key,
      type: "bar",
      stack: "total",
      data: data[key].data.map((item) => item.value),
      itemStyle: {
        color: data[key].color, // Apply color
        borderRadius: index === 1 ? [8, 8, 0, 0] : [0, 0, 0, 0], // Rounded corners for a rounded bar only for index 1
      },
      emphasis: {
        focus: "series",
      },
      label: {
        show: index === Object.keys(data).length - 1,
        position: "top",
        formatter: (params: { dataIndex: number }) => {
          const total = Object.keys(data).reduce(
            (sum, seriesKey) =>
              sum + data[seriesKey].data[params.dataIndex].value,
            0
          );
          return Math.round(total)?.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });
        },
        fontSize: 14,
      },
    })),
  };

  return (
    <ReactEcharts option={options} style={{ height: height, width: "100%" }} />
  );
};
